module.exports = __webpack_public_path__ + "assets/img/block-right-hover-0cab6e22.png";